import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=3377587a"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3377587a')) {
      api.createRecord('3377587a', component.options)
    } else {
      api.reload('3377587a', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=3377587a", function () {
      api.rerender('3377587a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainContent/Form.vue"
export default component.exports